export default __webpack_public_path__ + "3f9d82e33af20cd77824cdb9f44f44aa.png";